var Index_object_services_media_slider = document.querySelector('.Index_object_services_media_slider');

if (Index_object_services_media_slider) {
    new Swiper('.Index_object_services_media_slider', {
        loop: false,
        grabCursor: false,
        spaceBetween: 8,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1,
                spaceBetween: 12
            },
            750: {
                spaceBetween: 8
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
}

/* Team Drawer */
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.services_drawer_open');
  if (!trigger) return;

  const popupClass = trigger.getAttribute('popup_id');
  if (!popupClass) return;

  // close any open popup first (optional but recommended)
  document.querySelectorAll('.Services_innerdrawer_mainitem_new.open').forEach(el => el.classList.remove('open'));

  const target = document.querySelector(`.Services_innerdrawer_mainitem_new.${popupClass}`);
  if (!target) return;

  target.classList.add('open');
  document.body.classList.add('services_drawer_is_open');
});

document.addEventListener('click', function (e) {
  const closeTrigger = e.target.closest('.services_drawer_overlay_new, .services_drawer_close');
  if (!closeTrigger) return;

  document.body.classList.remove('services_drawer_is_open');

  document.querySelectorAll('.Services_innerdrawer_mainitem_new.open').forEach(el => el.classList.remove('open'));
});
/* Team Drawer */

/* Mobile scroll */
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 749) {
    const cards = document.querySelectorAll(".Services_innerloop_mainrows_new");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {

            const index = [...cards].indexOf(entry.target);

            // 🔥 Remove active from all cards
            cards.forEach(card => card.classList.remove("active"));

            // Add active to current card with stagger
            setTimeout(() => {
              entry.target.classList.add("active");
            }, index * 50);

          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    cards.forEach((card) => {
      observer.observe(card);
    });
  }
});